import { render } from "./AddressAutocompleteKleber.vue?vue&type=template&id=0ef39dfa&scoped=true"
import script from "./AddressAutocompleteKleber.vue?vue&type=script&lang=js"
export * from "./AddressAutocompleteKleber.vue?vue&type=script&lang=js"

import "./AddressAutocompleteKleber.vue?vue&type=style&index=0&id=0ef39dfa&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef39dfa"]])

export default __exports__